<span class="race-time">
    <span class="hours" *ngIf="timeObj.hours > 0">{{timeObj.hours}}:</span>
    <span class="min-sec">{{timeObj.minutes<10? '0'+timeObj.minutes : timeObj.minutes}}:{{timeObj.seconds}}</span>
    <span class="milli-sec">.{{timeObj.milliseconds}}</span> 
    <span class="unit">min</span>
</span>
